import { ReactElement, useState } from 'react';
import { onImageError } from '@helper/utils';
import { usePRecommendationKAEQuery } from '@services/hooks/contractor360KAE/usePRecommendationKAEQuery';
import { useLocation } from 'react-router-dom';
import { Wrapper } from '@components/common/Wrapper/wrapper';
import { useUpdatePCommentMutation } from '@services/hooks/contractor360KAE';
import { ToastType, useTosterStore } from '@store/toster';
import { NoDataFound } from '@components/common/no-data-found/noDataFound';

export const ProductRecommendedInfo = (): ReactElement => {
	const { state } = useLocation();
	const { setToaster } = useTosterStore();

	const {
		isFetching: isPRecommendedDataFetching,
		data: pRecommendedData,
		error: pRecommendedDataError,
	} = usePRecommendationKAEQuery(state?.siteId);
	const products = pRecommendedData?.products;

	const { mutate, isPending } = useUpdatePCommentMutation();

	const [comments, setComments] = useState<Record<number, string>>({});

	const handleInputChange = (commentId: number, value: string): void => {
		setComments((prev) => ({ ...prev, [commentId]: value }));
	};

	const handleUpdate = (commentId: number): void => {
		const updatedComment = comments[commentId];
		if (updatedComment !== undefined) {
			mutate(
				{ id: commentId, comments: updatedComment },
				{
					onSuccess: (data) => {
						if (data) {
							setToaster(true, ToastType.success, `Product feedback updated successfully`);
						}
					},
					onError: (error: Error) => {
						setToaster(true, ToastType.error, error.message);
					},
				}
			);
		}
	};

	return (
		<div className="p-recommended-info-section">
			<div className="title-with-line">Products recommended</div>

			<Wrapper isLoaderVisible={isPRecommendedDataFetching} isError={pRecommendedDataError}>
				<ul className="row">
					{products && products.length > 0 ? (
						products.map((p) => (
							<li key={p.product_code} className="d-col d-col-2">
								<div className="product-discussion-card" id="product-popup">
									<div className="product-image">
										<img
											role="presentation"
											src={p.image}
											alt={p.product_code}
											width="104"
											height="156"
											onError={onImageError}
										/>
									</div>

									<div className="product-details">
										<span className="h3">{p.product_code}</span>
										<span className="p-tag h4">Demo: {p.product_demo ? 'Yes' : 'No'}</span>

										{p.comment && (
											<div className="comments-card-wrapper">
												<span className="box-label">Product Feedback</span>
												<textarea
													id={`comments-${p.comment.id}`}
													name="comments"
													required
													value={comments[p.comment.id] ?? p.comment.comment}
													onChange={(e) => handleInputChange(p.comment.id, e.target.value)}
												/>
												<div className="update-btn">
													<button
														type="button"
														aria-label="update comment"
														className="btn"
														onClick={() => handleUpdate(p.comment.id)}
														disabled={isPending}
													>
														<span className="icon-edit-tag"></span>
													</button>
												</div>
											</div>
										)}
									</div>
								</div>
							</li>
						))
					) : (
						<NoDataFound message="No Data Found!" />
					)}
				</ul>
			</Wrapper>
		</div>
	);
};
